
<style lang='scss'>
</style>

<template>
  <div class="lookinfo">
    <Form :label-width="100"
          class="clearfix">
      <Col span='12'>
      <FormItem :label="$t('erp.virtualstore.transferordernum',{defaultValue:'调拨单号'})">
        <Input :value="formData.transferNo"
               disabled />
      </FormItem>
      </Col>
      <Col span='12'>
      <FormItem :label="$t('fbb.headlogistics.order_status',{defaultValue:'单据状态'})">
        <Select :value="formData.status"
                disabled>
          <Option value="DRAFT">{{$t('fbb.alloment.draft',{defaultValue:'草稿'})}}</Option>
          <Option value="ACTIVATE">{{$t('erp.channel.active',{defaultValue:'激活'})}}</Option>
          <Option value="CANCEL">{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span='24'>
      <Col span='12'>
      <FormItem :label="$t('erp.virtualstore.subordinateproject',{defaultValue:'所属项目'})">
        <Select :value="formData.lineId"
                disabled>
          <Option v-for="item in getNewProductList"
                  :value="item.value"
                  :key="item.value">{{ item.label }}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span='12'>
      <FormItem :label="$t('erp.virtualstore.actualoutwarehouse',{defaultValue:'实际出库仓库'})">
        <Select :value="formData.orgWarehouseId"
                disabled>
          <Option v-for="item in warehouses"
                  :value="item.id"
                  :key="item.id">{{ item.title }}</Option>
        </Select>
      </FormItem>
      </Col>
      </Col>
      <Col span='12'>
      <FormItem :label="$t('erp.virtualstore.virtualoutware',{defaultValue:'虚拟出库仓'})">
        <Input :value="formData.outWarehouseCode"
               disabled />
      </FormItem>
      </Col>
      <Col span='12'>
      <FormItem :label="$t('erp.virtualstore.virtualinware',{defaultValue:'虚拟入库仓'})">
        <Input :value="formData.inWarehouseCode"
               disabled />
      </FormItem>
      </Col>
      <Col span='24'>
      <FormItem :label="$t('global.common.reason',{defaultValue:'原因'})">
        <span>{{formData.description}}</span>
      </FormItem>
      </Col>
    </Form>
    <Table :height="160"
           :columns="columns"
           :data="data"
           :loading="loading"
           size="small"
           ref="table"
           border
           stripe></Table>
    <Spin size="large"
          fix
          v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpVsAllot } from '@/service/boss/allot';
import { HttpVsGroupData } from '@/service/boss/allot';
export default {
  props: ['id', 'type'],
  data () {
    return {
      data: [],
      loading: false,
      formData: {
        // transferNo: '',
        // lineId: '',
        // orgWarehouseId: '',
        // inWarehouse: '',
        // outWarehouse: '',
        // description: '',
        // status: ''
      },
      required: [{
        required: true,
        message: this.$t('global.common.required',{defaultValue:'该信息不能为空,请填写'})
      }],
    };
  },
  mounted () {
    this.getDetail();
  },

  methods: {
    handleResponse (data = {}) {
      const { transferNo, lineId, orgWarehouseId, inWarehouseCode, outWarehouseCode, description, status } = data;
      this.formData = {
        transferNo, lineId, orgWarehouseId, inWarehouseCode, outWarehouseCode, description, status
      };
      this.data = data.stockTransferItems || [];

    },
    async getDetail () {
      this.loading = true;
      HttpVsAllot({ id: this.id }).then(res => {
        this.handleResponse(res.data);
        this.loading = false;
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
        this.loading = false;
      })
    },

  },
  computed: {
    // ...mapState('boss',['products']),
    ...mapGetters('diction', ['getNewProductList']),
    ...mapGetters('boss', ['warehouses']),
    columns () {
      return [{
        title: 'ERPSKU',
        key: 'erpSku',
      },
      {
        title: this.$t('fbb.alloment.out_bound_number',{defaultValue:'出库数量'}),
        key: 'quantity',
      },];
    },
  },
};
</script>



